module.exports = __webpack_public_path__ + "assets/img/1.78f6254e.png";